import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarV2MinimalActionsDropdownTrigger from './VeltCommentsSidebarV2MinimalActionsDropdownTrigger/VeltCommentsSidebarV2MinimalActionsDropdownTrigger';
import VeltCommentsSidebarV2MinimalActionsDropdownContent from './VeltCommentsSidebarV2MinimalActionsDropdownContent/VeltCommentsSidebarV2MinimalActionsDropdownContent';
var VeltCommentsSidebarV2MinimalActionsDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2MinimalActionsDropdown.Trigger = VeltCommentsSidebarV2MinimalActionsDropdownTrigger;
VeltCommentsSidebarV2MinimalActionsDropdown.Content = VeltCommentsSidebarV2MinimalActionsDropdownContent;
export default VeltCommentsSidebarV2MinimalActionsDropdown;
